document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.contact__form');

  if (form) {
    // Prevenir que Enter envíe el formulario desde inputs
    form.addEventListener('keydown', function (e) {
      const isEnter = e.key === 'Enter' || e.keyCode === 13;
      const isTextField = ['text', 'email', 'tel', 'number', 'password', 'search'].includes(e.target.type);

      if (isEnter && isTextField) {
        e.preventDefault();
      }
    });
  }

  // Filtro para los campos de teléfono
  const phones = document.querySelectorAll('input[type="tel"]');
  phones.forEach(phone => {
    setInputFilter(phone, function (value) {
      return /^\d*(\d*\s?)*\d*$/.test(value); // Solo dígitos y espacios
    }, "Only digits and spaces are allowed");
  });

  // Validación de dominios de email con erratas (gmil, hormail, yahio...)
  const emails = document.querySelectorAll('input[type="email"][data-domain-check]');
  emails.forEach(setEmailDomainCheck);
});

// Proveedores habituales y sus extensiones válidas
const EMAIL_PROVIDERS = {
  gmail: ['com'],
  hotmail: ['com', 'es', 'fr', 'it', 'de', 'co.uk'],
  outlook: ['com', 'es', 'fr', 'it', 'de', 'pt', 'co.uk'],
  yahoo: ['com', 'es', 'fr', 'it', 'de', 'co.uk'],
  icloud: ['com'],
  protonmail: ['com', 'ch'],
  telefonica: ['net'],
  movistar: ['es']
};
// Dominios reales parecidos a un proveedor que no deben marcarse como erróneos
const EMAIL_LABEL_WHITELIST = ['mail', 'email', 'ymail', 'gmx', 'cloud'];
// Extensiones que no existen y siempre son una errata de .com
const EMAIL_TLD_TYPOS = ['con', 'cmo', 'ocm', 'comm', 'coom', 'cpm', 'vom', 'xom', 'cim', 'cok'];
// Extensiones reales que, junto a un proveedor conocido, son una errata de .com
const EMAIL_PROVIDER_TLD_TYPOS = ['co', 'cm', 'om', 'cn'];

// Distancia de edición contando la transposición de dos letras como un solo error (gamil → gmail)
function editDistance(a, b) {
  const d = [];
  for (let i = 0; i <= a.length; i++) d[i] = [i];
  for (let j = 0; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
  }
  return d[a.length][b.length];
}

// Devuelve el dominio corregido si el introducido parece una errata, o null si es correcto
function getEmailDomainSuggestion(domain) {
  const dot = domain.indexOf('.');

  // Dominio sin punto: "gmailcom"
  if (dot === -1) {
    const provider = Object.keys(EMAIL_PROVIDERS).find(p => domain.startsWith(p));
    return provider ? provider + '.' + EMAIL_PROVIDERS[provider][0] : domain + '.com';
  }

  const label = domain.slice(0, dot);
  const tld = domain.slice(dot + 1);
  const knownTlds = EMAIL_PROVIDERS[label];

  if (knownTlds) {
    if (knownTlds.includes(tld)) return null;
    if (label === 'gmail' || label === 'icloud' || EMAIL_TLD_TYPOS.includes(tld) || EMAIL_PROVIDER_TLD_TYPOS.includes(tld)) {
      return label + '.' + knownTlds[0];
    }
    return null;
  }

  const fixedTld = EMAIL_TLD_TYPOS.includes(tld) ? 'com' : tld;

  if (!EMAIL_LABEL_WHITELIST.includes(label)) {
    const provider = Object.keys(EMAIL_PROVIDERS).find(p => {
      const maxDistance = p.length <= 5 ? 1 : 2;
      return editDistance(label, p) <= maxDistance;
    });
    if (provider) {
      const providerTlds = EMAIL_PROVIDERS[provider];
      return provider + '.' + (providerTlds.includes(fixedTld) ? fixedTld : providerTlds[0]);
    }
  }

  return fixedTld !== tld ? label + '.' + fixedTld : null;
}

function setEmailDomainCheck(input) {
  const errorEl = input.parentElement.querySelector('.contact__form-field__error');
  const errorMsg = input.dataset.domainError;
  const suggestionMsg = input.dataset.domainSuggestion;

  function clearError() {
    input.classList.remove('input-error');
    input.removeAttribute('aria-invalid');
    input.setCustomValidity('');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function check() {
    const value = input.value.trim().toLowerCase();
    const at = value.lastIndexOf('@');
    if (at === -1 || at === value.length - 1) {
      clearError();
      return true;
    }

    const suggestion = getEmailDomainSuggestion(value.slice(at + 1));
    if (!suggestion) {
      clearError();
      return true;
    }

    const suggestedEmail = input.value.trim().slice(0, at) + '@' + suggestion;
    input.classList.add('input-error');
    input.setAttribute('aria-invalid', 'true');
    input.setCustomValidity(errorMsg);

    if (errorEl) {
      errorEl.textContent = errorMsg + ' ';
      const [before, after] = suggestionMsg.split('[email]');
      const fix = document.createElement('button');
      fix.type = 'button';
      fix.className = 'contact__form-field__suggestion';
      fix.textContent = suggestedEmail;
      fix.addEventListener('click', function () {
        input.value = suggestedEmail;
        check();
        input.focus();
      });
      errorEl.append(before || '', fix, after || '');
      errorEl.hidden = false;
    }
    return false;
  }

  input.addEventListener('blur', check);
  input.addEventListener('input', function () {
    if (input.classList.contains('input-error')) check();
  });
  if (input.form) {
    input.form.addEventListener('submit', function (e) {
      if (!check()) {
        e.preventDefault();
        input.focus();
      }
    });
  }
}

// Filtro de entrada
function setInputFilter(textbox, inputFilter, errMsg) {
  [
    "input", "keydown", "keyup", "mousedown", "mouseup",
    "select", "contextmenu", "drop", "focusout"
  ].forEach(function (event) {
    textbox.addEventListener(event, function (e) {
      if (inputFilter(this.value)) {
        if (["keydown", "mousedown", "focusout"].includes(e.type)) {
          this.classList.remove("input-error");
          this.setCustomValidity("");
        }
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.classList.add("input-error");
        this.setCustomValidity(errMsg);
        this.reportValidity();
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}
